<template>
  <div class="home-page">
    <!-- Electronics_Banner Arae -->
    <!-- v-if="sliderItems.length > 0" -->
    <section id="electronics_banner">
      <!-- :loop="true" -->
      <!-- :autoplay="true" -->
      <carousel
        class="electronics_slider_box"
        :margin="30"
        :items="2"
        :nav="true"
        :dots="true"
        :loop="true"
        :autoplay="true"
        :smartSpeed="1000"
        :responsive="{
          0: { items: 1 },
          600: { items: 1 },
          992: { items: 1 },
          1200: { items: 1 },
        }"
        @changed="handleSlideChange"
      >
        <div class="electronics_slider background_bg">
          <video ref="video1" width="100%" muted loop playsinline>
            <source
              :src="require('@/assets/slider1-video.mp4')"
              type="video/mp4"
            />
          </video>
        </div>
        <div class="electronics_slider background_bg">
          <video ref="video2" width="100%" muted loop playsinline>
            <source
              :src="require('@/assets/slider2-video.mp4')"
              type="video/mp4"
            />
          </video>
        </div>
        <!-- <div class="electronics_slider background_bg">
          <img :src="require('@/assets/img/TicasSlide1Updated.gif')" alt="" />
        </div> -->
        <!-- <div class="electronics_slider background_bg">
          <img :src="require('@/assets/img/TicasSlide2Updated.jpg')" alt="" />
        </div> -->
        <!-- <div class="electronics_slider background_bg">
          <img :src="require('@/assets/img/coverslider3-4.jpg')" alt="" />
        </div> -->
        <!-- <div
          v-for="sliderItem in sliderItems"
          :key="sliderItem.id"
          class="electronics_slider background_bg"
        >
          <img :src="sliderItem.path" alt="" />
          <div class="container">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="electronics_slider_content">
                  <h2 v-if="sliderItem.overlay_text">
                    {{ sliderItem.overlay_text }}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </carousel>
    </section>

    <section
      class="fade-in-section delay-1 welcome-ticas-section"
      v-scroll-fade
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="center_heading_three">
              <h2>Welcome To TICA'S</h2>
              <p class="text-center mt-3">
                Welcome to TICA’S, a distinguished textiles company that has
                been setting the standard for quality and creativity since its
                inception in 2010. <br />
                At TICA’S, we believe that fabrics and textiles are more than
                just materials; they are the essence of home and lifestyle
                expression. <br />
                Our commitment to excellence is not only in the products we
                create but also in the stories, emotions, and visions woven into
                every thread...
              </p>
              <router-link
                to="/about-us"
                class="theme-btn-one bg-black btn_sm mt-4"
                style="margin-top: 3rem !important"
                >Read More</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Electronics_Banner_Bottom Arae -->
    <section
      id="electronics_banner_bottom"
      class="ptb-100 fade-in-section delay-1"
      v-scroll-fade
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-4">
            <div class="product_variation_one_boxed img-zoom-hover">
              <img
                :src="require('@/assets/img/Ticas-Category-small-size1.jpg')"
                alt="img"
              />
              <div class="product_var_one_text">
                <h4 class="color_one">Table</h4>
                <router-link to="/shop" class="theme-btn-one bg-black btn_sm"
                  >Shop Now</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <div class="product_variation_one_boxed img-zoom-hover">
              <img
                :src="require('@/assets/img/Ticas-Category-small-size2.jpg')"
                alt="img"
              />
              <div class="product_var_one_text">
                <h4 class="color_one">Towels</h4>
                <router-link to="/shop" class="theme-btn-one bg-black btn_sm"
                  >Shop Now</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4">
            <div class="product_variation_one_boxed img-zoom-hover">
              <img
                :src="require('@/assets/img/Ticas-Category-small-size3.jpg')"
                alt="img"
              />
              <div class="product_var_one_text">
                <h4 class="color_one">Lifestyle</h4>
                <router-link to="/shop" class="theme-btn-one bg-black btn_sm"
                  >Shop Now</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-none">
            <div class="el_banner_bottom el-ban-bottom-left">
              <router-link to="/shop">
                <img
                  style="cursor: pointer"
                  :src="require('@/assets/img/electronics/common/offer1.jpg')"
                  alt="img"
                />
              </router-link>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-none">
            <div class="el_banner_bottom">
              <router-link to="/shop">
                <img
                  style="cursor: pointer"
                  :src="require('@/assets/img/electronics/common/offer2.jpg')"
                  alt="img"
                />
              </router-link>
            </div>
            <div class="el_banner_bottom">
              <router-link to="/shop">
                <img
                  style="cursor: pointer"
                  :src="require('@/assets/img/electronics/common/offer3.jpg')"
                  alt="img"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Top Product Area -->
    <section
      id="electronics_top_product"
      class="ptb-100 fade-in-section"
      v-if="false"
    >
      <div class="container">
        <div class="row mb-6">
          <div class="col-md-12 col-lg-12">
            <div>
              <h2 style="padding-left: 20px">Categories</h2>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div>
            <b-tabs
              vertical
              class="hot-product-area-tabs electronics-product-tabs tabs_right_button"
            >
              <b-tab
                :title="collection.name"
                v-for="(collection, idx) in categoriesWithProducts"
                :key="idx"
                class="row"
                :disabled="collection.is_parent"
                :class="collection.is_parent ? 'parent' : 'child'"
                :active="collection.active"
              >
                <div
                  class="col-lg-3 col-md-4 col-sm-6 col-12"
                  v-for="(product, index) in collection.products"
                  :key="index"
                >
                  <ProductBox4 :product="product" :index="index" />
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </section>

    <!--Top Products Arae -->
    <section
      id="elce_weekly_deal"
      class="ptb-100 slider_arrows_on fade-in-section delay-3"
      v-if="featuredOrNewProducts.length > 0"
      v-scroll-fade
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="left_heading_three">
              <h2>Top Products</h2>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <swiper
              class="swiper todays_slider position-relative"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="(product, index) in featuredOrNewProducts"
                :key="index"
              >
                <ProductBox4 :product="product" :index="index" />
              </swiper-slide>

              <div
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <!--Sale Product Arae -->
    <section
      id="elce_weekly_deal"
      class="ptb-100 slider_arrows_on fade-in-section delay-3 gray-section"
      v-if="saleProducts.length > 0"
      v-scroll-fade
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="left_heading_three">
              <h2>Sale Products</h2>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <swiper
              class="swiper todays_slider position-relative"
              :options="swiperOption"
            >
              <swiper-slide
                v-for="(product, index) in saleProducts"
                :key="index"
              >
                <ProductBox4 :product="product" :index="index" />
              </swiper-slide>

              <div
                class="swiper-button-prev swiper-button-white"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-button-white"
                slot="button-next"
              ></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section
      id="special_offer_one"
      class="fade-in-section delay-4"
      v-scroll-fade
    >
      <img :src="require('@/assets/img/offer-banner.jpg')" alt="" />
      <div class="container">
        <div class="row">
          <div class="col-lg-4 offset-lg-4 col-md-12 col-sm-12 col-12">
            <div class="offer_banner_one text-center">
              <h3 class="fw-600">Trendy Collections</h3>
              <p style="padding-top: 10px">
                “Unveiling Elegance in Every Thread, Weaving Dreams into
                Reality.”
              </p>
              <router-link to="/shop" class="theme-btn-one bg-whites btn_md"
                >Shop Now</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      id="grocery_support"
      class="pb-100 fade-in-section delay-3"
      v-scroll-fade
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="grcery_support_boxed">
              <img
                :src="require('@/assets/img/grocery/icon/free.svg')"
                alt="icon"
              />
              <div class="support_boxed_grocery_content">
                <h5>Global Delivery</h5>
                <p>We deliver every where</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="grcery_support_boxed">
              <img
                :src="require('@/assets/img/grocery/icon/refund.svg')"
                alt="icon"
              />
              <div class="support_boxed_grocery_content">
                <h5>Refundable</h5>
                <p>Terms & conditions apply</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="grcery_support_boxed">
              <img
                :src="require('@/assets/img/grocery/icon/secure.svg')"
                alt="icon"
              />
              <div class="support_boxed_grocery_content">
                <h5>Secure Payment</h5>
                <p>100% secure payment</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="grcery_support_boxed">
              <img
                :src="require('@/assets/img/grocery/icon/support.svg')"
                alt="icon"
              />
              <div class="support_boxed_grocery_content">
                <h5>Customer Support</h5>
                <p>Dedicated to serve you</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Alert ref="alert"></Alert>
    <!-- Add to Compare / Compare Notification  -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProductBox4 from "../components/products/ProductBox";
// import InstagramAreaElectronics from "../components/instagram/InstagramAreaElectronics";
import carousel from "vue-owl-carousel";

export default {
  name: "Home",
  components: {
    ProductBox4,
    carousel,
  },

  data() {
    return {
      // Furniture Banner Slider Items
      sliderItems: [],

      products: [],
      saleProducts: [],
      featuredOrNewProducts: [],
      category: [],
      cartproduct: {},
      categoriesWithProducts: [
        {
          name: "Placemats",
          parent: "Table",
        },
        {
          name: "Cutlery Sleeves",
          parent: "Table",
        },
        {
          name: "Tissue Box",
          parent: "Table",
        },
        {
          name: "Table Runner",
          parent: "Table",
        },
        {
          name: "Tablecloth",
          parent: "Table",
        },
        {
          name: "Napkins",
          parent: "Table",
        },
        {
          name: "Coasters",
          parent: "Table",
        },
        {
          name: "Breadbasket",
          parent: "Table",
        },
        {
          name: "Guest Towels",
          parent: "Towels",
        },
        {
          name: "Beach Towel",
          parent: "Towels",
        },
        {
          name: "Hand Towels",
          parent: "Towels",
        },
        {
          name: "Hammam Towel",
          parent: "Towels",
        },
        {
          name: "Tote Bag",
          parent: "Tote Bag",
        },
        {
          name: "Beach Bag",
          parent: "Beach Bag",
        },
        {
          name: "Pouch",
          parent: "Pouch",
        },
      ],

      compareproduct: {},

      dismissCountDown: 0,

      // Todays Slider options
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 30,
        loop: false,
        mousewheel: false,
        keyboard: {
          enabled: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        autoplay: false,
      },
    };
  },
  computed: {
    ...mapState({
      productslist: (state) => state.products.productslist,
    }),
  },
  created() {
    this.getSliderItems();
    this.getCategoriesWithProducts();
    this.getProductsWithOptions();
    // For scroll page top for every Route
    window.scrollTo(0, 0);
  },
  mounted() {
    // For scroll page top for every Route
    window.scrollTo(0, 0);

    // document.addEventListener("DOMContentLoaded", () => {
    //   const fadeSections = document.querySelectorAll(".fade-in-section");
    //   const observer = new IntersectionObserver(
    //     (entries) => {
    //       entries.forEach((entry) => {
    //         if (entry.isIntersecting) {
    //           entry.target.classList.add("visible");
    //           observer.unobserve(entry.target); // animate only once
    //         }
    //       });
    //     },
    //     {
    //       threshold: 0.1,
    //       rootMargin: "0px 0px -100px 0px", // Adjust so it's not triggered too early
    //     },
    //   );
    //   fadeSections.forEach((section) => observer.observe(section));
    // });
    if (this.$refs.video1) {
      this.$refs.video1.play();
    }
  },
  methods: {
    getCategoriesWithProducts() {
      this.$http.get("categories-with-products").then((res) => {
        // console.log(res);
        this.categoriesWithProducts = res.data.data;
      });
    },
    getProductsWithOptions() {
      this.$http.get("products-with-options").then((res) => {
        // console.log(res);
        this.saleProducts = res.data.data.sale_products;
        this.featuredOrNewProducts = res.data.data.new_or_featured_products;
      });
    },

    // GetSlider Items
    getSliderItems: function () {
      this.$http.get("slider").then((res) => {
        this.sliderItems = res.data.data.items;
      });
    },

    handleSlideChange(event) {
      // console.log("count", event.item.count);
      const currentIndex = (event.item.index + 1) % 3; // Adjusting for 0-based index
      const videos = [this.$refs.video1, this.$refs.video2];
      videos.forEach((video, index) => {
        if (!video) return;

        if (index === currentIndex) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0;
        }
      });
    },
  },
};
</script>
